import React, { useEffect, useState, useRef, forwardRef } from 'react';
import { LiveService } from '../services/live-service';
import { Link } from 'react-router-dom';
import Loading from "../components/layouts/loading";
import TitleGrows from "../components/title-grows";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'

//Material
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import { withStyles } from '@mui/styles';

//Snackbar, Menu
//import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { UrlsUtils } from '../utils/UrlsUtils';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



export default function LiveView({ onUpdateCB, tagId = '', liveId = '', tableHeight = '1024px',
    isSelecting = false, isMultipleSelection = true, light = false, onlyVisualization = false }) {

    let MAX_LENGTH = 69;
    let TableCell = withStyles(theme => ({
        root: {
            height: 50,
            padding: 8,
        }
    }))(MuiTableCell);
    let columns = [
        { id: 'id', label: 'ID', width: 40, minWidth: 40, align: 'left' },
        { id: 'fb_video_id', label: 'FB_VIDEO_ID', width: 90, minWidth: 90, align: 'left' }, //, fweight: 'bold' },
        {
            id: 'title',
            label: 'TITLE',
            minWidth: 180,
            align: 'left',
            format: (value) => value.length > MAX_LENGTH ? `${value.toLocaleString('it-IT').substring(0, MAX_LENGTH)}...` : value.toLocaleString('it-IT'),
        },
        {
            id: 'description',
            label: 'DESCRIPTION',
            minWidth: 200,
            align: 'left',
            format: (value) => value.length > MAX_LENGTH ? `${value.toLocaleString('it-IT').substring(0, MAX_LENGTH)}...` : value.toLocaleString('it-IT'),
        },
        {
            id: 'publication_date',
            label: 'PUBLISHED',
            width: 90,
            minWidth: 90,
            align: 'left',
            format: (value) => value !== null ? `${moment(value).locale("it").format(`DD/MM/YYYY`)}` : ""
        },
        {
            id: 'tags',
            label: 'TAGS',
            minWidth: 180,
            align: 'left',
            //format: (value) => value
        },
    ];

    const searchIdRef = useRef();
    const searchTDRef = useRef();
    const radioAscDesc = useRef();
    const arrOrdering = ['publication_date', 'title', 'fb_video_id', 'id'];

    const [liveviewList, setLiveviewList] = useState([]);
    const [lcount, setLcount] = useState(0);
    const [selected, setSelected] = useState([]);
    const [searchId, setSearchId] = useState('');
    const [searchTD, setSearchTD] = useState('');
    const [ordering, setOrdering] = useState(arrOrdering[0]);
    const [ascDesc, setAscDesc] = useState('-');

    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: 'success',
        ahduration: 3000,
        instructions: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    const { open, vertical, horizontal, message, severity, ahduration, instructions } = state;

    //Table Material
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(!light ? 10 : 5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    if (light) {
        MAX_LENGTH = 120;
        TableCell = withStyles(theme => ({
            root: {
                height: 36,
                padding: 4,
            }
        }))(MuiTableCell);
        columns = [
            { id: 'id', label: 'ID', width: 40, minWidth: 40, align: 'left' },
            { id: 'fb_video_id', label: 'FB_VIDEO_ID', width: 90, minWidth: 90, align: 'left' }, //, fweight: 'bold' },
            {
                id: 'title',
                label: 'TITLE',
                minWidth: 150,
                align: 'left',
                format: (value) => value.length > MAX_LENGTH ? `${value.toLocaleString('it-IT').substring(0, MAX_LENGTH)}...` : value.toLocaleString('it-IT'),
            },
            {
                id: 'publication_date',
                label: 'PUBLISHED',
                width: 90,
                minWidth: 90,
                align: 'left',
                format: (value) => value !== null ? `${moment(value).locale("it").format(`DD/MM/YYYY`)}` : ""
            },
        ];
    }

    const handleClickCB = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        if (isMultipleSelection) {
            let newSelected = [];
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, id);
            } else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            } else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(
                    selected.slice(0, selectedIndex),
                    selected.slice(selectedIndex + 1),
                );
            }
            setSelected(newSelected);
        } else {
            setSelected([]);
            if (selectedIndex === -1) {
                setSelected([id]);
            }
        }
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    useEffect(() => {
        //console.log('table liveview selected : ', selected)
        //Array CheckBox selected (Multiselection or Singleselection)
        if (onUpdateCB) onUpdateCB(selected);
    }, [selected, onUpdateCB]);

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            const allview = await LiveService.getList(
                {
                    page: page + 1,
                    page_size: rowsPerPage,
                    id: liveId,
                    search: searchId,
                    search_td: searchTD,
                    ordering: `${ascDesc}${ordering}`,
                    tags__id: tagId
                }
            );
            setLiveviewList(allview.results);
            setLcount(allview.count);
            setIsLoading(false);
        }
        fetchData();
    }, [page, rowsPerPage, searchId, searchTD, ordering, ascDesc, tagId, liveId]);

    /* const handleOpen = (newState) => () => {
        setState({ open: true, ...newState });
    }; */

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    function goSearchId() {
        searchTDRef.current.value = '';
        setSearchTD('');
        setSearchId(searchIdRef.current.value); setPage(0);
    }

    const handleKeyDownId = (event) => {
        if (event.key === 'Enter') {
            goSearchId();
        }
    }

    function goSearchTD() {
        searchIdRef.current.value = '';
        setSearchId('');
        setSearchTD(searchTDRef.current.value); setPage(0);
    }

    const handleKeyDownTD = (event) => {
        if (event.key === 'Enter') {
            goSearchTD();
        }
    }

    const [anchorEl, setAnchorEl] = useState(null);
    const mopen = Boolean(anchorEl);
    const handleOrderClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    function handleOrderClose() {
        setAnchorEl(null);
    }

    function resetAll() {
        setPage(0);
        setSearchId('');
        setSearchTD('');
        setOrdering(arrOrdering[0]);
        setAscDesc('-');
    }

    return (
        <>
            {!light && (tagId > 0 ? <TitleGrows txtTitle={'Lives/Videos for the tag ' + tagId} />
                :
                <TitleGrows txtTitle={'All Lives/Videos'} />)}
            <>
                {isLoading && <Loading />}
                <main>
                    {!onlyVisualization && <div className="container-fluid" style={{ minHeight: "46px" }}>
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-3 col-xl-3 d-flex justify-content-center">
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Search ID/FB_Video_ID"
                                        onKeyDown={handleKeyDownId} ref={searchIdRef} defaultValue={searchId}
                                        aria-label="Search ID live" aria-describedby="button-search" />
                                    <IconButton className="cancel-input" edge="end" aria-label="delete-id" title=""
                                        id="button-delete-id" onClick={() => { searchIdRef.current.value = ''; setSearchId('') }} >
                                        <FontAwesomeIcon icon={['fas', 'times']} size={'1x'} color={'lightgray'} />
                                    </IconButton>
                                    <button className="btn btn-primary" type="button" id="button-search"
                                        onClick={() => { goSearchId(); }}>
                                        <FontAwesomeIcon icon={['fas', 'search']} size={'1x'} color={'white'} />
                                    </button>
                                </div>
                            </div>

                            <div className="col-12 col-md-12 col-lg-3 col-xl-3 d-flex justify-content-center">
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Search Title/Description"
                                        onKeyDown={handleKeyDownTD} ref={searchTDRef} defaultValue={searchTD}
                                        aria-label="Search Title/Description live" aria-describedby="button-search" />
                                    <IconButton className="cancel-input" edge="end" aria-label="delete-td" title=""
                                        id="button-delete-td" onClick={() => { searchTDRef.current.value = ''; setSearchTD('') }} >
                                        <FontAwesomeIcon icon={['fas', 'times']} size={'1x'} color={'lightgray'} />
                                    </IconButton>
                                    <button className="btn btn-primary" type="button" id="button-search"
                                        onClick={() => { goSearchTD(); }}>
                                        <FontAwesomeIcon icon={['fas', 'search']} size={'1x'} color={'white'} />
                                    </button>
                                </div>
                            </div>

                            <div className="col-12 col-md-12 col-lg-3 col-xl-3 d-flex justify-content-center">
                                <div>
                                    <button type="button" className="btn btn-secondary" data-bs-display="static" aria-expanded="false"
                                        onClick={handleOrderClick} style={{ minWidth: "230px", padding: "6px 20px 6px 20px" }} >
                                        Sort by: {ordering}
                                    </button>
                                    <Menu
                                        id="basic-menu"
                                        anchorEl={anchorEl}
                                        open={mopen}
                                        onClose={handleOrderClose}
                                        MenuListProps={{
                                            'aria-labelledby': 'basic-button',
                                        }}
                                    >
                                        {arrOrdering.map((e, i) => {
                                            return <MenuItem key={i} onClick={() => { handleOrderClose(); setOrdering(e); setPage(0); }}>{e}</MenuItem>
                                        })}
                                    </Menu>
                                </div>
                            </div>
                            <div className="col-12 col-md-12 col-lg-2 col-xl-2 d-flex justify-content-center">
                                <div className="ab">
                                    <input type="radio" value="" name="ordv" onChange={(e) => { setAscDesc(e.target.value); setPage(0); }} ref={radioAscDesc} checked={ascDesc === ''} />
                                    <span>Asc</span>
                                    <span style={{ margin: "0 8px" }}></span>
                                    <input type="radio" value="-" name="ordv" onChange={(e) => { setAscDesc(e.target.value); setPage(0); }} ref={radioAscDesc} checked={ascDesc === '-'} />
                                    <span>Desc</span>
                                </div>
                            </div>
                            <div className="col-12 col-md-12 col-lg-1 col-xl-1 d-flex justify-content-center">
                                <button onClick={() => { resetAll() }}
                                    className="badge btn-primary btn-sm text-wrap" >
                                    Reset</button>
                            </div>
                        </div>
                    </div>}

                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ height: tableHeight }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {isSelecting && <TableCell sx={{
                                            bgcolor: "#212529", color: "white", textAlign:
                                                "center", minWidth: "58px"
                                        }}></TableCell>}
                                        <TableCell sx={{ bgcolor: "#212529", color: "white", textAlign: "center", width: "160px" }}>
                                            TIMG
                                        </TableCell>
                                        <TableCell sx={{ bgcolor: "#212529", color: "white", textAlign: "center" }}>
                                        </TableCell>
                                        {columns.map((column) => (
                                            <TableCell sx={{ bgcolor: "#212529", color: "white" }}
                                                key={column.id}
                                                align={column.align}
                                                style={{ width: column.width, minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))
                                        }
                                        {!light && <TableCell sx={{ textAlign: "center", bgcolor: "#212529", color: "white", minWidth: "92px" }}>
                                            TOT: {lcount}
                                        </TableCell>
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    <>
                                        {(liveviewList?.length > 0) ?
                                            liveviewList.map((row, key) => {
                                                const isItemSelected = isSelected(row.id);
                                                return (
                                                    <TableRow
                                                        hover
                                                        onClick={(event) => handleClickCB(event, row.id)}
                                                        role="checkbox"
                                                        aria-checked={isItemSelected}
                                                        tabIndex={-1}
                                                        key={key}
                                                        selected={isItemSelected}
                                                        sx={{ height: 80, minHeight: 80 }}>
                                                        {isSelecting && <TableCell padding="checkbox">
                                                            <Checkbox
                                                                color="primary"
                                                                checked={isItemSelected}
                                                                inputProps={{
                                                                    'aria-label': 'select live/video',
                                                                }}
                                                            />
                                                        </TableCell>}
                                                        {!light ?
                                                            <TableCell sx={{ textAlign: "center" }}>
                                                                <a type="button" href={UrlsUtils.recognizingUrl(row.fb_url) ? row.fb_url : 'https://www.facebook.com' + row.fb_url}
                                                                    className="my-tooltip" title="Apri StartupItalia FB" target="_blank" rel="noopener noreferrer">
                                                                    <img src={row.thumbnail ? row.thumbnail : row.fb_thumbnail} className="img-thumbnail" alt='Thumbnail url'
                                                                        style={{ objectFit: "contain", minWidth: "8.88rem", maxHeight: "5rem", padding: "0px", border: "0px", boxShadow: "0px 0px 5px 0px #6c757d" }}></img>
                                                                </a>
                                                            </TableCell> :
                                                            <TableCell sx={{ textAlign: "center", maxWidth: "80px" }}>
                                                                <img src={row.thumbnail ? row.thumbnail : row.fb_thumbnail} className="img-thumbnail" alt='Thumbnail url'
                                                                    style={{ objectFit: "contain", minWidth: "7rem", maxHeight: "4rem", padding: "0px", border: "0px", boxShadow: "0px 0px 5px 0px #6c757d" }}>
                                                                </img>
                                                            </TableCell>
                                                        }
                                                        {!light ? <TableCell>
                                                            <Link to={{ pathname: "/livedetail/" + row.id }}
                                                                key={row.id}
                                                                liveview={row}
                                                            >
                                                                {row.is_fb_live ?
                                                                    <FontAwesomeIcon icon={['fas', 'video']} size={'1x'} color={'#6c757d'} title="Dettaglio della live" />
                                                                    :
                                                                    <FontAwesomeIcon icon={['fab', 'youtube']} size={'1x'} color={'#6c757d'} title="Dettaglio del video" />
                                                                }
                                                            </Link>
                                                        </TableCell>
                                                            : <TableCell>
                                                                {row.is_fb_live ?
                                                                    <FontAwesomeIcon icon={['fas', 'video']} size={'1x'} color={'#6c757d'} title="Live" />
                                                                    :
                                                                    <FontAwesomeIcon icon={['fab', 'youtube']} size={'1x'} color={'#6c757d'} title="Video" />
                                                                }
                                                            </TableCell>}
                                                        {columns.map((column) => {
                                                            const value = row[column.id];
                                                            return (
                                                                <TableCell key={column.id} sx={{ align: column.align, fontWeight: column.fweight }}>
                                                                    {column.format && typeof value === 'string'
                                                                        ? column.format(value)
                                                                        :
                                                                        column.id === 'tags' && typeof value === 'object' ?
                                                                            <>
                                                                                <ul className="list-group list-group-flush" style={{ listStyleType: "none" }}>
                                                                                    {value?.length > 0 && value.map((e, index) => (
                                                                                        <li className="list-group-item" style={{ padding: "1px" }} key={index}>
                                                                                            <Link to={{ pathname: "/livetagdetail/" + e?.id }} key={e.id}
                                                                                                title="Vai al dettaglio del tag"
                                                                                            >
                                                                                                {e?.id === Number(tagId) && value?.length > 1 ?
                                                                                                    <div style={{ fontWeight: 700, fontSize: "16px", color: "#198754" }}>
                                                                                                        <FontAwesomeIcon icon={['fas', 'chevron-right']} size={'1x'} color={'#198754'}
                                                                                                            style={{ marginRight: "8px" }} />
                                                                                                        {e?.name}
                                                                                                        {/* <span> ({e?.id})</span> */}
                                                                                                    </div>
                                                                                                    :
                                                                                                    e?.name
                                                                                                }
                                                                                            </Link>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            </>
                                                                            : value
                                                                    }
                                                                </TableCell>
                                                            );
                                                        })}
                                                        {!light &&
                                                            <TableCell sx={{ textAlign: "center" }}>
                                                                <Link to={{ pathname: "/livedetail/" + row.id }}
                                                                    key={row.id}
                                                                    liveview={row}
                                                                >
                                                                    {row.is_fb_live ?
                                                                        <FontAwesomeIcon icon={['fas', 'edit']} size={'2x'} color={'#0D6EFD'} title={'Dettaglio della live'} />
                                                                        :
                                                                        <FontAwesomeIcon icon={['fas', 'edit']} size={'2x'} color={'#0D6EFD'} title={'Dettaglio del video'} />
                                                                    }
                                                                </Link>
                                                            </TableCell>
                                                        }
                                                    </TableRow>
                                                )
                                            }) :
                                            < TableRow >
                                                <TableCell colSpan={5} >
                                                    <h6 style={{ width: "100%", textAlign: "center", margin: "6px" }}>
                                                        Nessun risultato trovato
                                                    </h6>
                                                </TableCell>
                                            </TableRow>
                                        }
                                    </>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {!onlyVisualization && <TablePagination
                            rowsPerPageOptions={!light ? [10, 25, 50] : [5, 10, 25, 50]}
                            component="div"
                            count={lcount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />}
                    </Paper>
                    <div style={{ height: "20px" }}></div>
                </main>

                <Snackbar open={open} autoHideDuration={ahduration} onClose={handleClose}
                    anchorOrigin={{ vertical, horizontal }} >
                    <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                        <div style={{ textAlign: "center" }}>{message}</div>
                        {instructions ?
                            <Alert severity="info" sx={{ margin: "10px 0 0 0" }}>
                                <div>
                                    Istruzioni:
                                </div>
                                {instructions}
                            </Alert>
                            : ''}
                    </Alert>
                </Snackbar>
            </>
        </>
    );

}
